import React from "react";
import { Line } from "./styled";

const CommonLine = () => {
  return <Line />;
};

export default CommonLine;
